import Api from '@/api/index';

const Company = {
  namespaced: true,
  state: { //dado read only, e qm pode alterar esses dados são as mutations! VARIAVEIS
    allCompanies: null, //para o index, e vai tomar um push(newEmployee ao criar)
    errorMessage: null,
    errorActive: null,
  },
  mutations: {// altera os dados do state
    getCompanies(state, c){
      state.allCompanies = c.data;
      //console.log(state.allBanks);
    },

    setErrorMessage(state, {message, status}){
      state.errorMessage = message;
      state.errorActive = status;
    }
  },
  actions: { //chamar o método dentro dos componentes
    index(context){
      Api.Company.index()
        .then(response => response.data)
        .then(c => {
          context.commit('getCompanies', c);
          context.commit('setErrorMessage', {message: '', status: false})
        }).catch(function(error) {
          console.log(error);
        });
    },
  }
};

export default Company;